import React, { useState, useEffect } from 'react';
import { Phone, AlertCircle } from 'lucide-react';
import { useEmergencyNumber } from '../../hooks/useEmergencyNumber';

export default function EmergencyBanner() {
  const { emergencyNumber, country } = useEmergencyNumber();
  const [isFloating, setIsFloating] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsFloating(window.scrollY > 64); // Header height
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="py-2">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <AlertCircle className="w-5 h-5 text-red-600" />
            <div className="flex items-center gap-2">
              <span className="font-semibold text-red-900">Medical Emergency?</span>
              <span className="hidden sm:inline text-sm text-red-700">
                {country && `Call emergency services in ${country}`}
              </span>
            </div>
          </div>
          
          <a
            href={`tel:${emergencyNumber}`}
            className="inline-flex items-center px-3 py-1 text-sm font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 transition-colors"
          >
            <Phone className="w-4 h-4 mr-1.5" />
            {emergencyNumber}
          </a>
        </div>
      </div>
    </div>
  );
}
